export default __webpack_public_path__ + "static/media/afternoon-nothing.6578acbd.png";